import { reskinStyles } from 'core/components/theme/theme-variant';
const overrideTabs = (theme) => {
  theme.overrides.MuiTabs = {
    flexContainer: {
      justifyContent: 'center'
    },
    indicator: {
      height: 4
    }
  };
  theme.overrides.MuiTab = {
    root: {
      fontSize: 24,
      fontStretch: 'normal',
      lineHeight: 1.25,
      color: theme.colors.text_primary,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: theme.colorPalette.orange_50_op_08,
        ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_50, color: theme.colors.action_text })
      }
    },
    wrapper: {
      '@media (min-width: 0px)': {
        padding: theme.spacing(0, 5)
      }
    },
    selected: {
      fontWeight: 500
    }
  };
};

export default overrideTabs;
